import { ServiceMaker, methods, services } from "@/services";

export const createTemplateEmail = payload =>
  ServiceMaker(
    `/communication/templates`,
    methods.POST,
    services.master,
    payload
  );

export const updateTemplateEmail = payload =>
  ServiceMaker(
    `/communication/templates/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );

  export const fetchEditTemplate = id =>
  ServiceMaker(
    `/communication/templates/detail/${id}`,
    methods.GET,
    services.master
  ); 

export const fetchTemplateAll = () =>
  ServiceMaker(
    `/communication/templates`,
    methods.GET,
    services.master
  );

export const deleteTemplate = (payload) =>
  ServiceMaker(
    `/communication/templates/${payload}`,
    methods.DELETE,
    services.master,
    payload
  );

export const concernOptionList = () =>
  ServiceMaker(
    `/communication/templates/concern/list`,
    methods.GET,
    services.master
  );